import React from 'react';
import { useQuery } from '@tanstack/react-query';
import api from '../lib/api';
import { Card, CardHeader, CardContent } from '../components/ui/Card';
import { User, Mail, Phone, Globe, Hash } from 'lucide-react';

export default function ProfilePage() {
  const { data: profile } = useQuery({ queryKey: ['profile'], queryFn: () => api.get('/users/me').then(r => r.data) });

  return (
    <div className="max-w-lg mx-auto space-y-6 animate-fade-in">
      <div className="d-page-header">
        <h1 className="text-2xl font-bold text-white">My Profile</h1>
        <p className="text-slate-400 mt-1">Your account information.</p>
      </div>

      <Card>
        <CardHeader><h2 className="text-base font-semibold text-white">Profile Information</h2></CardHeader>
        <CardContent>
          {/* Avatar */}
          <div className="flex items-center gap-4 mb-6">
            <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-primary-600 to-accent flex items-center justify-center">
              <span className="text-2xl font-bold text-white">{profile?.username?.[0]?.toUpperCase() || 'U'}</span>
            </div>
            <div>
              <p className="font-bold text-lg text-white">{profile?.profile?.fullName || profile?.username}</p>
              <p className="text-sm text-slate-400">@{profile?.username}</p>
            </div>
          </div>

          {/* Info */}
          <div className="space-y-3">
            {[
              { icon: Mail, label: 'Email', value: profile?.email },
              { icon: Phone, label: 'Mobile', value: profile?.mobile },
              { icon: Globe, label: 'Country', value: profile?.profile?.country || '-' },
              { icon: Hash, label: 'Referral Code', value: profile?.referralCode, mono: true },
            ].map((item) => (
              <div key={item.label} className="flex items-center gap-3 p-3.5 rounded-xl bg-white/[0.02] border border-white/[0.04]">
                <div className="w-9 h-9 rounded-lg bg-white/[0.04] flex items-center justify-center shrink-0">
                  <item.icon className="w-4 h-4 text-slate-400" />
                </div>
                <div>
                  <p className="text-xs text-slate-500">{item.label}</p>
                  <p className={`text-sm font-medium text-white ${item.mono ? 'font-mono' : ''}`}>{item.value}</p>
                </div>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
